"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.287 6.164a.7.7 0 0 1 .99 0l5.981 5.984c.567.567 1.179.811 1.749.811.57 0 1.182-.244 1.749-.811l5.966-5.97a.7.7 0 1 1 .99.99l-5.966 5.97c-.788.787-1.743 1.221-2.739 1.221-.996 0-1.951-.433-2.739-1.222L3.287 7.154a.7.7 0 0 1 0-.99Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.175 11.463a.7.7 0 0 1 .088.986l-5.14 6.14a.7.7 0 0 1-1.074-.898l5.14-6.14a.7.7 0 0 1 .986-.088Zm5.657 0a.7.7 0 0 1 .986.088l5.13 6.13a.7.7 0 0 1-1.074.898l-5.13-6.13a.7.7 0 0 1 .088-.986Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 6.5a1.7 1.7 0 0 1 1.7-1.7h16.6A1.7 1.7 0 0 1 22 6.5v11a1.7 1.7 0 0 1-1.7 1.7H3.7A1.7 1.7 0 0 1 2 17.5v-11Zm1.7-.3a.3.3 0 0 0-.3.3v11a.3.3 0 0 0 .3.3h16.6a.3.3 0 0 0 .3-.3v-11a.3.3 0 0 0-.3-.3H3.7Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EmailIcon24.js.map